module.exports = __webpack_public_path__ + "img/cei.3647370d.png";